import React from "react";
import { MainDiv } from "../../components/Profile/Profile.style";
import Submenu from "../../components/Security/Submenu/Submenu";
import { VolunteerHeading } from "../../components/Volunteer/Volunteer.style";

const SubMenuSetupPage = () => {
  return (
    <MainDiv>
      <VolunteerHeading>Submenu Setup</VolunteerHeading>
      <Submenu />
    </MainDiv>
  );
};

export default SubMenuSetupPage;
